// extracted by mini-css-extract-plugin
export default {"mainContainer":"ViewerElementSection_mainContainer__ra1Ad"};